function _typeof(obj) {
  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  }

  return _assertThisInitialized(self);
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

import { writeText } from 'clipboard-polyfill';
import { LocaleContext } from "../../context/locale/localeContext/LocaleContext";
import memoizeOne from 'memoize-one';
import React, { Component } from 'react';
import { ButtonTypes } from "../button/Button.types";
import { CopyButton, SecredFieldWrapper, SecretText, ToggleButton } from "./SecretField.styles";
export var SecretField =
/*#__PURE__*/
function (_Component) {
  _inherits(SecretField, _Component);

  function SecretField(props) {
    var _this;

    _classCallCheck(this, SecretField);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(SecretField).call(this, props));

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "generateRandomString", void 0);

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "state", {
      isReadable: false
    });

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "toggleReadable", function () {
      return _this.setState({
        isReadable: !_this.state.isReadable
      });
    });

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "copy", function () {
      return writeText(_this.props.value);
    });

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "generateRandomSegment", function () {
      return (Math.random() * Math.pow(2, 50)).toString(36).replace(/\./g, '');
    });

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "generateNextRandomString", function (length) {
      var stringSoFar = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';

      if (stringSoFar.length >= length) {
        return stringSoFar.substr(0, length);
      }

      return _this.generateRandomString(length, stringSoFar + _this.generateRandomSegment());
    });

    _this.generateRandomString = memoizeOne(_this.generateNextRandomString);
    return _this;
  }

  _createClass(SecretField, [{
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props = this.props,
          value = _this$props.value,
          copyText = _this$props.copyText,
          hideText = _this$props.hideText,
          showText = _this$props.showText,
          onCopy = _this$props.onCopy;
      var secret = this.generateRandomString(value.length);

      var copy = function copy() {
        if (onCopy) {
          onCopy();
        }

        writeText(_this2.props.value);
      };

      return React.createElement(SecredFieldWrapper, {
        className: "secret-field"
      }, React.createElement(SecretText, {
        className: "secret-field__text",
        "data-testid": "secret-text",
        isReadable: this.state.isReadable
      }, this.state.isReadable ? this.props.value : secret), React.createElement(ToggleButton, {
        className: "secret-field__toggle",
        "data-testid": "secret-toggle",
        onClick: this.toggleReadable,
        type: ButtonTypes.FLAT
      }, this.state.isReadable ? hideText : showText), React.createElement(CopyButton, {
        className: "secret-field__copy",
        "data-testid": "secret-copy",
        onClick: copy,
        type: ButtonTypes.FLAT
      }, copyText));
    }
  }]);

  return SecretField;
}(Component);

_defineProperty(SecretField, "contextType", LocaleContext);